import queryString from 'query-string';

import handleFetchResponse from './handleFetchResponse';
import { AUTH_COOKIE, getCookie } from './cookies';

export default (url, options, callback, includeCredentials = true, catchCallback) => {
  if (typeof url !== 'string') throw Error('Invalid parameter: url');
  if (typeof options !== 'object' && options !== null) throw Error('Invalid parameter: options');
  if (typeof callback !== 'function') throw Error('Invalid parameter: callback');

  const urlParameters = options ? `?${queryString.stringify(options)}` : '';

  const authToken = getCookie(AUTH_COOKIE);

  const settings = {
    method: 'get',
    ...(includeCredentials && { credentials: 'include' }),
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
      ...(!!authToken && { authorization: `Bearer ${authToken}` }),
    },
  };

  fetch(url + urlParameters, settings)
    .then((response) => handleFetchResponse(response, catchCallback))
    .then(callback);
};
